const REPORT_STATE_KEY = "reportState";
const REPORT_STATE_VERSION = 1;
const REPORT_STATE_TTL_MS = 2 * 60 * 60 * 1000;

function isObject(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

function isValidReportState(value) {
  if (!isObject(value)) return false;

  const scores = value.scores;
  if (!isObject(scores) || !isObject(scores.categories) || typeof scores.overall !== "number") {
    return false;
  }

  if (value.insights != null && !Array.isArray(value.insights)) return false;
  if (value.restaurant != null && !isObject(value.restaurant)) return false;

  return true;
}

export function writeReportState(reportState, options = {}) {
  if (!isValidReportState(reportState)) return false;

  const envelope = {
    version: REPORT_STATE_VERSION,
    savedAt: Date.now(),
    source: options.source || "unknown",
    reportState,
  };

  try {
    sessionStorage.setItem(REPORT_STATE_KEY, JSON.stringify(envelope));
    return true;
  } catch {
    return false;
  }
}

export function clearReportState() {
  try {
    sessionStorage.removeItem(REPORT_STATE_KEY);
  } catch {}
}

export function readStoredReportState(maxAgeMs = REPORT_STATE_TTL_MS) {
  try {
    const raw = sessionStorage.getItem(REPORT_STATE_KEY);
    if (!raw) return null;

    const envelope = JSON.parse(raw);
    if (!isObject(envelope) || envelope.version !== REPORT_STATE_VERSION) {
      clearReportState();
      return null;
    }

    const savedAt = Number(envelope.savedAt || 0);
    if (!savedAt || Date.now() - savedAt > maxAgeMs) {
      clearReportState();
      return null;
    }

    if (!isValidReportState(envelope.reportState)) {
      clearReportState();
      return null;
    }

    return envelope.reportState;
  } catch {
    clearReportState();
    return null;
  }
}

export function resolveReportState(locationState, maxAgeMs = REPORT_STATE_TTL_MS) {
  if (isValidReportState(locationState)) {
    return locationState;
  }

  return readStoredReportState(maxAgeMs);
}

export { REPORT_STATE_TTL_MS };